import axios from './fetch'
import request from './request'
import {
	captchaUrl,
	loginInfoUrl,
	loginUrl,
	logoutUrl,
	passwordResetUrl,
	phoneLoginUrl,
	registerUrl,
	sendSmsCodeUrl,
	sendUpgradeSmsCodeUrl,
	vertifyUpgradeSmsCodeUrl,
	uploadImgUrl,
} from './url'
import memoRequest from '@/utils/memoRequest'

const commonUrl: any = {
	login: loginUrl,
	sendSmsCode: sendSmsCodeUrl,
	sendUpgradeSmsCode: sendUpgradeSmsCodeUrl,
	vertifyUpgradeSmsCode: vertifyUpgradeSmsCodeUrl,
	phoneLogin: phoneLoginUrl,
	loginInfo: loginInfoUrl,
	register: registerUrl,
	captcha: captchaUrl,
	logout: logoutUrl,
	passwordReset: passwordResetUrl,
	uploadImg: uploadImgUrl,
}

export interface MemoFunc<R = any> {
	(...args: any[]): Promise<R>;
	value?: Promise<R>;
}

/**
 * get请求
 */
export function getFetch(action: string, params: object = {}) {
	return axios.get(commonUrl[action], {
		params,
	})
}

/**
 * post请求
 */
export function postFetch(action: string, data: object = {}) {
	return axios.post(commonUrl[action], data)
}

/** 获取国家列表 */
export function getCountryList() {
	return request.get('/api/common/getCountryList').then((data) => data.list)
}

/** 获取币种列表 */
export const getCurrecyList: MemoFunc = () => {
	if (!getCurrecyList.value) {
		getCurrecyList.value = request
			.get('/api/common/getCurrecyList')
			.then((data) => data.list)
			.catch((err) => {
				getCurrecyList.value = undefined
				return Promise.reject(err)
			})
	}
	return getCurrecyList.value
}

/** 获取镜外银行列表 */
export const getOutsideBankList = memoRequest(() => {
	return request
		.get('/api/common/getOutsideBankList')
		.then((data) => data.list)
})

/** 查询一级经营类目列表 */
export function getCategoriesList() {
	return request
		.get('/api/common/queryFirstCategorys')
		.then((data) => data.list)
}

/** 查询一级分类下联系人邮箱 */
export function getCategoriesDetail(id: number | string) {
	return request
		.get(`/api/common/querySubCategorys?fid=${id}`)
		.then((data) => data.list)
}
